import Image from "../../atoms/image/image";
import styles from "./VasModal.module.scss";
import config from "../../../config/index";
import PropTypes from "prop-types";
import {
  Modal,
  CustomContainer,
  Row,
  Col,
  Link
} from "../../atoms/DependencyHelper";
import * as Analytics from "../../../services/analyticsUtag";
import { MOBILE_WIDTH, TABLET_WIDE_WIDTH } from "../../../config/constants";
import { useState, useEffect } from "react";
import { getVasItems } from '../../../services/vasDataService';
import { numberFormat, createMarkup , componentCheckSize} from '../../../utils/helperServices';

const VasModal = ({
  handleCancel,
  handleAddToCart,
  showModal,
  cartData
}) => {
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;

  const isMobile = componentCheckSize() < MOBILE_WIDTH;
  const isDesktop = componentCheckSize() > TABLET_WIDE_WIDTH;
  const [totalPrice, setTotalPrice] = useState(0);
  const [vasDataSource, setvasDataSource] = useState([]);
  const [noContentText, setNoContentText] = useState(false);
  const [updateOnce, setUpdateOnce] = useState(true);
  const [selectedDealPrice, setSelectedDealPrice] = useState();

  const selectedItem = (selectedVasItem, dealPrice, shouldUpdate) => {
    dealPrice = (Math.round(dealPrice * 100) / 100).toFixed(2);

    const updatedVasArray = vasDataSource.map(vasItem => {
      if (selectedVasItem) {
        if (!shouldUpdate) {
          if (vasItem.vidCode === selectedVasItem.product.sku) {
            vasItem.isAdded = true;
          }
        } else {
          if (vasItem.vidCode === selectedVasItem.vidCode) {
            vasItem.isAdded = !vasItem.isAdded;
          }
        }
      }

      return { ...vasItem };
    });

    for (const iterator of updatedVasArray) {
      if (iterator?.isAdded) {
        dealPrice = Math.round((+dealPrice + +iterator.price) * 100) / 100;
      }
    }

    setTotalPrice(dealPrice);

    if (shouldUpdate) {
      setvasDataSource(updatedVasArray);
    }
  };

  const getDealWithPrice = () => {
    const dealProduct = cartData.find(
      cartProduct =>
        cartProduct?.product?.is_deal_product === 1
    );
    setSelectedDealPrice(dealProduct.product.monthly_recurring);
    return dealProduct;
  }

  const getVASFromCart = (currentDeal) => {
    const vasProduct = cartData.filter(
      cartProduct =>
        cartProduct?.parent_product_sku == currentDeal.product.sku
    );
    return vasProduct;
  }

  const setErrorAnalytics = () => {
    Analytics.link({
      page_name: "shopping: deal details",
      page_form_event: "error",
      page_errors: "There are no insurance products available for this deal",
      page_error_type: "page",
    });
  }

  useEffect(() => {
    const deal = getDealWithPrice();
    let mounted = true;
    showSpinner();
    getVasItems(deal.product.sku).then(data => {
      hideSpinner();
      if (mounted) {
        if (data && data.length === 0) {
          setErrorAnalytics();
          setNoContentText(true);
        } else {
          setvasDataSource(data);
        }
      }
    }).catch(error => {
      hideSpinner();
      setNoContentText(true);
    });
    return () => {
      mounted = false;
    }
  }, []);

  useEffect(() => {
    if (vasDataSource) {
      updateModalDataSource();
    }
  }, [vasDataSource])

  const updateModalDataSource = () => {
    const deal = getDealWithPrice();
    const dealPrice = deal.product.monthly_recurring;
    if (vasDataSource.length !== 0) {
      const vasProducts = getVASFromCart(deal);
      if (updateOnce) {
        if (vasProducts && vasProducts.length) {
          vasProducts.forEach(item => {
            selectedItem(item, dealPrice, false);
          });
        } else {
          selectedItem(undefined, dealPrice, false);
        }
      }
      //To avoid calling selectedItem everytime vasDataSource is updated
      setUpdateOnce(false);
    }
  }

  const getVasCategory = (vasData, type) => {
    let vasProperty;
    if (vasData) {
      try {
        if (type === 'icon') {
          vasProperty = vasData?.vasDetails?.image?.url;
          if (vasProperty.includes("No_image")) {
            const vasCategoryIcon = vasData?.vasDetails?.categories.sort((a, b) => b.level - a.level)[0];
            vasProperty = vasCategoryIcon.image;
          }
        } else if (type === 'category_url') {
          const vasCategoryUrl = vasData?.vasDetails?.categories.sort((a, b) => b.level - a.level)[0];
          vasProperty = vasCategoryUrl.category_url;
        }
      } catch (error) {
        vasProperty = '';
      }
    }
    return vasProperty;
  }

  const showSpinner = () => {
    var element = document.getElementById("modalLoader");
    if (element) {
      element.classList.add("showspin");
    }
  };
  
  const hideSpinner = () => {
    var element = document.getElementById("modalLoader");
    if (element) {
      element.classList.remove("showspin");
    }
  };

  return (
    showModal && (
      <Modal
        show={showModal}
        dialogClassName={`${styles["vas-modal"]}`}
        onHide={handleCancel}
        centered
      >
        {!isMobile && (<Modal.Header className={styles["vasmodal-header"]}>
          <Image
            className={styles["close-button"]}
            img_path={`${imagePrefix}/assets/images/modal-close.svg`}
            onClick={handleCancel}
          />
          <span>
            Add contract / device insurance
          </span>
        </Modal.Header>
        )}

        {isMobile && (<Modal.Header className={styles["vasmodal-header"]}>
          <Image
            className={styles["close-button"]}
            img_path={`${imagePrefix}/assets/images/modal-close.svg`}
            onClick={handleCancel}
          />
        </Modal.Header>)}

        <Modal.Body className={noContentText ? styles["modal-noContent"] : styles["modal-body"]}>
          <CustomContainer id="modalLoader" className={styles["loader"]}></CustomContainer>
          <CustomContainer className={styles["container"]}>
            {vasDataSource.map((item, index) => (<CustomContainer key={index} className={styles["card"]}
              onClick={() => {
                selectedItem(item, selectedDealPrice, true);
              }}>
              <CustomContainer className={styles["card-container"]}>
                <CustomContainer className={styles["card__image-container"]}>
                  <img
                    className={styles["card__image"]}
                    src={getVasCategory(item, 'icon')}
                  /></CustomContainer>
                <CustomContainer>
                  <CustomContainer className={styles["card__image-text"]}>
                    {item?.vasDetails?.name}
                  </CustomContainer>
                  <CustomContainer className={styles["card__description"]}
                    dangerouslySetInnerHTML={createMarkup(item?.vasDetails?.description?.html)}>
                  </CustomContainer>
                  {isDesktop && (<CustomContainer className={styles["card__link"]}>
                    <Link legacyBehavior href={getVasCategory(item, 'category_url')} passHref={true}>
                      <a target="_blank" className={styles["card__link"]}>
                        See more info
                      </a>
                    </Link>
                  </CustomContainer>
                  )}
                </CustomContainer>

                {isDesktop && (<CustomContainer className={styles["card__price"]}>{"+ R"}{numberFormat(item.price)}{" PM"}</CustomContainer>)}
                {isDesktop && (<CustomContainer>
                  {item?.isAdded && (<img
                    className={styles["card__selected"]}
                    src={`${imagePrefix}/assets/images/tick-marks.svg`} />
                  )}
                  {!item?.isAdded && (<CustomContainer className={styles["card__unselected"]}>
                  </CustomContainer>)}
                </CustomContainer>
                )}
              </CustomContainer>
              <CustomContainer className={styles["footer"]}>
                {!isDesktop && (<CustomContainer className={styles["card__link"]}>
                  <Link legacyBehavior href={getVasCategory(item, 'category_url')} passHref={true}>
                    <a target="_blank" className={styles["card__link"]}>
                      See more info
                    </a>
                  </Link>
                </CustomContainer>)}
                {!isDesktop && (<CustomContainer className={styles["footer__price"]}>
                  <CustomContainer className={styles["card__price"]}>{"+ R"}{numberFormat(item.price)}{" PM"}</CustomContainer>
                  <CustomContainer>
                    {item?.isAdded && (<img
                      className={styles["card__selected"]}
                      src={`${imagePrefix}/assets/images/tick-marks.svg`} />
                    )}
                    {!item?.isAdded && (<CustomContainer className={styles["card__unselected"]}>
                    </CustomContainer>)}
                  </CustomContainer>
                </CustomContainer>)}
              </CustomContainer>
            </CustomContainer>
            ))}
          </CustomContainer>


          {noContentText && (<CustomContainer className={styles["noContent-container"]}>
            <CustomContainer className={styles["noContent"]}>
              <img
                className={styles["noContent-info-button"]}
                src={`${imagePrefix}/assets/images/icon-info.svg`}
              />
              <span>{"There are no insurance products available for this deal"}</span>
            </CustomContainer>
            <button
              className={styles["close"]}
              onClick={handleCancel}
            >
              <label className={styles["label"]}>{"Close"}</label>
            </button>
          </CustomContainer>
          )}
        </Modal.Body>
        {!isMobile && vasDataSource.length > 0 && (<Row className={styles["modal-footer"]}>
          <Col className={styles["modal-footer-total"]}>{"Your monthly total:"}
            <span className={styles["modal-footer-amount"]}>{`R${numberFormat(totalPrice)}`}</span></Col>
          <Row>
            <Col className={styles["modal-footer-cancel"]} onClick={handleCancel}>{"Cancel"}</Col>
            <button
              className={styles["modal-footer-cancel-button"]}
              disabled={!vasDataSource.length}
              onClick={e => {
                e.stopPropagation();
                handleAddToCart(vasDataSource)
              }}
            >
              <label
                className={styles["button-label"]}
              >
                {"Add to cart"}
              </label>
            </button>
          </Row>
        </Row>)}

        {isMobile && vasDataSource.length > 0 && (<CustomContainer className={styles["modal-footer"]}>
          <CustomContainer className={styles["modal-footer-total"]}>{"Your monthly total:"}
            <span className={styles["modal-footer-amount"]}>{`R${numberFormat(totalPrice)}`}</span></CustomContainer>
          <button
            className={styles["modal-footer-cancel-button"]}
            disabled={!vasDataSource.length}
            onClick={e => {
              e.stopPropagation();
              handleAddToCart(vasDataSource)
            }}
          >
            <label
              className={styles["button-label"]}
            >
              {"Add to cart"}
            </label>
          </button>
          <CustomContainer className={styles["modal-footer-cancel"]}>{"Cancel"}</CustomContainer>
        </CustomContainer>)}
      </Modal>
    )
  );
};

VasModal.propType = {
  handleCancel: PropTypes.func,
  handleAddToCart: PropTypes.func,
  showModal: PropTypes.bool,
  cartData: PropTypes.array
};

export default VasModal;
